<template>
    <v-container fluid class="d-flex pa-0 fullHeight">
      <v-container class="container-custom px-6" v-if="!editTemplateStatus">
        <Breadcrumbs
        :title="$t('modules.messaging.template.editMessage.breadcrumbs.title')"
        :description="$t('modules.messaging.template.editMessage.breadcrumbs.description')"
        ></Breadcrumbs>
        <v-row justify="center">
          <v-col sm="12" class="viewSpaces">
            <OutlinedCard>
              <OutlinedCard
               :title="$t('modules.messaging.template.editMessage.messageBody')"
                :switchLabel="formattedStatusTemplates"
                switcher
                :switchValue="messageContent.status"
                @switchChange="messageContent.status = !messageContent.status"
                class="mb-6"
              >
                <v-row>
                  <v-col cols="12" lg="12" class="pb-0">
                  <v-text-field
                    :label="$t('modules.messaging.template.editMessage.messageTitle')"
                    outlined
                    required
                    class="mb-8"
                     v-model="$v.messageContent.title.$model"
                   :error-messages="($v.messageContent.title.$dirty && $v.messageContent.title.$invalid) ?
                    ((!$v.messageContent.title.required) ? $t('modules.messaging.template.createMessage.validations.messageContent.title.requerido') :

                    (!$v.messageContent.title.maxLength) ? $t('modules.messaging.template.createMessage.validations.messageContent.title.maxLength') :
                    '') :
                    ''"
                     ref="title"
                     @blur="$v.messageContent.title.$touch()"
                  ></v-text-field>
                  <v-text-field
                    :label="$t('modules.messaging.template.editMessage.messageSubtitle')"
                    outlined
                    required
                    class="mb-6"
                    v-model="$v.messageContent.subtitle.$model"
                     :error-messages="($v.messageContent.subtitle.$dirty && $v.messageContent.subtitle.$invalid) ?
                    ((!$v.messageContent.subtitle.required) ? $t('modules.messaging.template.createMessage.validations.messageContent.subtitle.requerido') :

                    (!$v.messageContent.subtitle.maxLength) ? $t('modules.messaging.template.createMessage.validations.messageContent.subtitle.maxLength') :
                    '') :
                    ''"
                    ref="subtitle"
                     @blur="$v.messageContent.subtitle.$touch()"
                  ></v-text-field>
                  <div>
                    <h2 class="mb-6 body-1 ">
                    {{ $t('modules.messaging.template.editMessage.messageBodyHtml') }}</h2>
                  <vue-editor v-model="messageContent.message" ref="message" />
                  </div>
                </v-col>
                </v-row>
              </OutlinedCard>
              
              <OutlinedCard
               :title="$t('modules.messaging.template.editMessage.messageSignature')"
               >
                <v-row class="signature-container">
                  <v-col cols="2" lg="2" class="pb-0">
                    <AvatarUpload
                    :size="formattSize"
                    :rounded="true"
                    :image="imagePreview"
                    :label="$t('modules.messaging.template.editMessage.messageImage')"
                    @save="(file) => createImage(file)"
                  ></AvatarUpload>
                  </v-col>
                  <v-col cols="6" lg="6" class="pb-0">
                  <v-text-field
                    :label="$t('modules.messaging.template.editMessage.messageFullname')"
                    outlined
                    required
                    class="mb-6"
                   :error-messages="($v.messageContent.name.$dirty && $v.messageContent.name.$invalid) ?
                    ((!$v.messageContent.name.required) ? $t('modules.messaging.template.createMessage.validations.messageContent.name.requerido') :

                    (!$v.messageContent.name.maxLength) ? $t('modules.messaging.template.createMessage.validations.messageContent.name.maxLength') :
                    '') :
                    ''"
                    ref="name"
                     @blur="$v.messageContent.name.$touch()"
                    v-model="$v.messageContent.name.$model"
                  ></v-text-field>
                  <v-text-field
                    :label="$t('modules.messaging.template.editMessage.messagePosition')"
                    outlined
                    required
                    class="mb-6"
                   v-model="$v.messageContent.place.$model"
                    :error-messages="($v.messageContent.place.$dirty && $v.messageContent.place.$invalid) ?
                    ((!$v.messageContent.place.required) ? $t('modules.messaging.template.createMessage.validations.messageContent.place.requerido') :

                    (!$v.messageContent.place.maxLength) ? $t('modules.messaging.template.createMessage.validations.messageContent.place.maxLength') :
                    '') :
                    ''"
                      ref="place"
                     @blur="$v.messageContent.place.$touch()"
                  ></v-text-field>
                </v-col>
                </v-row>
              </OutlinedCard>
               <!-- <OutlinedCard
                :title="$t('modules.messaging.template.editMessage.vigencia.title')"
                :subtitle="$t('modules.messaging.template.editMessage.vigencia.subtitle')"
              >
                <v-row class="d-flex">
                  <v-col class="d-flex justify-start" cols="12" sm="4">
                      <v-select
                          v-model="selectVigencia"
                          :items="vigencia"
                          :label="$t('modules.messaging.template.editMessage.vigencia.label')"
                          item-text="value"
                          return-object
                          outlined
                      ></v-select>
                  </v-col>
                </v-row>
              </OutlinedCard> -->
            </OutlinedCard>
             <OutlinedCard
                :title="$t('modules.messaging.template.editMessage.destinatarios.title')"
                :subtitle="$t('modules.messaging.template.editMessage.destinatarios.subtitle')"
              >
                <div class="mx-5 d-flex justify-end">
                    <a href="/templates/envio-mensajeria.xlsx" download>
                        <Button
                            outlined
                            class=" mb-8"
                            icon="mdi-download"
                            :text="$t('modules.messaging.template.areaTemplates.sendMessage.download_template')"
                        ></Button>
                    </a>
                </div>
                <v-col cols="12">
                <DropFiles
                    :key="dropFilesKey"
                    v-model="file"
                    class="mx-5 mt-5"
                    extension=".xls,.xlsx"
                    limitSizeBytes="2000000"
                    type-file="excel"
                ></DropFiles>
            </v-col>
            </OutlinedCard>
            <div class="d-flex justify-end mb-4">
              <Button
                depressed
                white
                @clicked="$router.go(-1)"
                @end="resetButtonValues"
                :text="$t('actions.cancel')"
                class="mr-4"
              ></Button>
              <Button
                :loading="createButton.loading"
                :success="createButton.success"
                :error="createButton.error"
                :text="$t('actions.edit')"
                :successText="$t('actions.created')"
                :errorText="'Error'"
                color="primary"
                @end="resetButtonValues"
                @clicked="validateMessage"
              ></Button>
            </div>
          </v-col>
      </v-row> 
      </v-container>
       <SuccessMessage
        v-else
        :type="successMessage.type"
        :title="successMessage.title"
        :actionPrimary="successMessage.actionPrimary"
        :actionSecondary="successMessage.actionSecondary"
      />
    </v-container>

</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs/Breadcrumbs'
import OutlinedCard from '@/components/OutlinedCard/OutlinedCard';
import AvatarUpload from '@/components/AvatarUpload/AvatarUpload';
import Button from '@/components/Button/Button';
import DropFiles from '@/components/DropFiles/DropFiles';
import { VueEditor } from 'vue2-editor';
import constants from '@/plugins/constants';
import SuccessMessage from '@/components/SuccessMessage/SuccessMessage';
import { mapGetters } from 'vuex'

import {
  required,
  maxLength, 
  } from 'vuelidate/lib/validators';
import { $templates } from '../Services';

export default {
name:'TemplateUpdate',
components: {
  Breadcrumbs,
  OutlinedCard,
  VueEditor,
  AvatarUpload,
  Button,
  SuccessMessage,
  DropFiles
},

data: () => ({
    createButton: {
        loading: false,
        success: false,
        error: false
      },
    messageContent: {
      title:'',
      subtitle:'',
      message: '',
      name: '',
      place: '',
      status:true,
      area:{
        id:''
    }
  },
  status:true,
  avatar: '',
  imagePreview: '',
  successMessage: {
        type: null,
        title: null,
        actionPrimary: null,
        actionSecondary: null
      },
  selectedTemplate: null,
  vigencia:[
    {value:'1 dias' ,id:1},
    {value: '3 dias' ,id:3},
    {value:'7 dias' ,id:7},
    {value: '15 dia',id:15},
  ],
  selectVigencia: null,
  sendDocumentationStatus: false,
  file: null,
  dropFilesKey: 0,
  template: null,
  editTemplateStatus: false
}),
computed:{
  formattedStatusTemplates () {
      return this.messageContent.status ? this.$t('modules.prices.update.section_product.enabled') : this.$t('modules.prices.update.section_product.disabled')
    },
    isMobile() {
      let check = false;
      //eslint-disable-next-line
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      return check;
    },
    formattSize(){
      return this.isMobile ? 40 : 135
    },
    ...mapGetters({
        userId: 'commons/getUserID',
    }),
},
methods: {
async updateTemplate(body){
  const token = localStorage.getItem('access_token')
    ? JSON.parse(localStorage.getItem('access_token'))
    : '';
  const options = {
    method: 'PUT',
    mode: 'cors',
    cache: 'no-cache',
    headers: {
      Authorization: `Bearer ${token}`
    },
    body
  };
  try {
    await fetch(`${constants.URL_BASE}/messages/templates/${this.$route.params.id}`,options);
  } catch (error) {
    this.loading = false;
    throw error;
  } finally {
    this.loading = false;
  }
},
createImage(file) {
  try {
    this.avatar = file;
    const reader = new FileReader();

    reader.onload = (e) => {
      this.setImagePreview(e.target.result);
    };
    reader.onerror = () => {
      this.setImagePreview(this.avatar);
      reader.abort();
    };
    reader.readAsDataURL(this.avatar);
  } catch (err) {
    this.setImagePreview(this.avatar);
  }
},
setImagePreview(image) {
  this.imagePreview = image;
},
resetButtonValues() {
      this.createButton.loading = false;
      this.createButton.success = false;
      this.createButton.error = false;
    },
clearData() {
  this.resetButtonValues();
 
  // this.$v.$reset();
},
validateMessage() {
      if (this.$v.$invalid ) {
        this.$v.$touch();
        Object.keys(this.$v.messageContent).some(input => {
            if (input.includes('$')) return false;
            if (this.$v.messageContent[input].$error) {
              this.$refs[input][0]
                ? this.$refs[input][0].$el.scrollIntoView({block: 'center', behavior: 'smooth'})
                : this.$refs[input].$el.scrollIntoView({block: 'center', behavior: 'smooth'});
              return true;
            }
          });
        } else {
          this.editMessage()
        }
    },
async editMessage() {
  this.createButton.loading = true;
  try {
  const messageTemplate = JSON.stringify(this.messageContent)
     const formData = new FormData();
     formData.append('template', messageTemplate);
     formData.append('avatar', this.avatar)
     formData.append('id', this.$route.params.id)
  

  await $templates.formData(formData, 'update' ,null);

   if(this.file){
      const formData = new FormData()
          formData.append('file', this.file);
          formData.append('userId', this.userId);
      await $templates.formData(formData, 'send', this.$route.params.id)
   }
      this.successMessage.type = 'success';
        this.successMessage.title = this.$t('modules.messaging.template.editMessage.successMessage.title');
        this.successMessage.actionPrimary = {
          text: this.$t('actions.close'), callback: () => {
            this.$router.push(`/messaging/templates/area/${this.messageContent.area.id}`);
          }
        };
        this.successMessage.actionSecondary = null;
        this.editTemplateStatus = true;
        this.createButton.success = true;
        this.createButton.loading = false;
        this.clearData();
     
   } catch (error) {
     this.successMessage.type = 'error';
        this.successMessage.title = (error.codeMeaning != '') ? error.codeMeaning : this.$t('modules.messaging.template.editMessage.errorMessage.title');
        this.successMessage.actionPrimary = {
          text: this.$t('actions.return'), callback: () => {
            this.editTemplateStatus = false;
          }
        };
        this.successMessage.actionSecondary = null;
        this.editTemplateStatus = true;
        this.createButton.loading = false;
        this.createButton.error = true;
        throw error;
   }
},
createMessagePopUp () {
      if (!this.messageContent.status) {
        this.$store.dispatch('commons/openPopUp', {
          title: this.$t('alert'),
          content: [{ value: this.$t('disabledMessage') }],
          actionPrimary: { text: this.$t('actions.accept'), callback: () => this.editMessage() },
          actionSecondary: { text: this.$t('actions.cancel'), callback () { } },
          icon: { color: 'warning', name: 'mdi-alert' },
          color: 'primary',
        });
      } else {
         this.editMessage()
      }
    },
async fetchData(templateId) {
  try {
      const response = await $templates.findById(templateId)
    this.messageContent.title = response.data.title
    this.messageContent.subtitle = response.data.subtitle
    this.messageContent.title = response.data.title
    this.messageContent.message = response.data.message
    this.messageContent.name = response.data.name
    this.messageContent.place = response.data.place
    this.imagePreview = response.data.avatar ? `data:image/png;base64,${response.data.avatar}` : ''
    this.avatar = response.data.avatar
    this.messageContent.status = response.data.status
    this.messageContent.area.id = response.data.area.id
    } catch (error) {
    this.messageContent.title = ''
    this.messageContent.subtitle = ''
    this.messageContent.title = ''
    this.messageContent.message = ''
    this.messageContent.name = ''
    this.messageContent.place = ''
    this.status = true
    this.messageContent.area.id = this.$route.params.id
      throw error;
    }
  
  },
},
mounted(){
  const template = this.$route.params.id;
  this.fetchData(template);
},
validations: {
  messageContent:{
    title:{
      required,
      maxLength: maxLength(60),
    },
    subtitle:{
      required,
      maxLength: maxLength(60),
    },
    message:{
      required
    },
    name:{
      required,
      maxLength: maxLength(30),
    },
    place:{
      required,
      maxLength: maxLength(60),
    }
  },
    // selectVigencia:{
    //   required
    // }
  }
}

</script>

<style lang="sass" scoped>
.signature-container
  justify-content: space-around

</style>
